// removed by extract-text-webpack-plugin
module.exports = {"sort_item":"_3E5EYer6XhdO_1x5WsllAU"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/NavigationSort/NavigationSort.scss
// module id = 2136
// module chunks = 1